import useOrganization from './useOrganization';

/* returns whether Calls is activated in the current organization. */
const useIsCallsActivatedOrganization = () => {
  const isCallsActivatedOrganization = useOrganization((current) => current.is_calls_enabled);
  return isCallsActivatedOrganization;
};

export default useIsCallsActivatedOrganization;
